import React, { useState } from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from '@mui/material/styles';
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const rows = [
  { slNo: 1, description: "New * Notification of IDP SHIMLA 13-08-2015*.", date: '06-Aug-2016', pdfUrl: "922b7c5a-2cf4-49cd-acd8-44dad4978bfc" },
  { slNo: 2, description: "Clarification regarding mis - interpreting of Basements", date: '24-May-2019', pdfUrl: "c4c36397-cabb-41f7-beff-8ad6b043dd46" },
  { slNo: 3, description: "Notice for publication of proposed amendment(s) in development plans.", date: '28-Sep-2016', pdfUrl: "a173e383-59e9-432b-b243-4f7e37d016ba" },
  { slNo: 4, description: "Amendment in IDP Shimla notification dated 28/06/2016.", date: '28-Sep-2016', pdfUrl: "e1d4eac0-c3d0-48b0-b09c-165a3b8d4303" },
  { slNo: 5, description: "EXEMPTIONS IN RURAL AREAS-CLARIFICATIONS THEREOF", date: '28-Sep-2016', pdfUrl: "0507dbe5-9d3f-48e1-953c-e4c7be478f72" },
  { slNo: 6, description: "Policy on section 16(c) of HPTCP, Act 1977", date: '28-Sep-2016', pdfUrl: "60eefb8e-bd0f-4db6-bcf9-ab577a8e6945" },
  { slNo: 7, description: "Policy for Establishment of “Dr. A.P.J. Abdul Kalam e-Map Centre” in Town and Country Planning Department and Special Area Development Authority (SADA).", date: '28-Sep-2016', pdfUrl: "0c42c936-8bce-4f96-bf1c-d17c107edc58" },
  { slNo: 8, description: "Comparison between notifications dated 28.02.2011 and 13.08.2015 in respect of IDP,Shimla.", date: '28-Sep-2016', pdfUrl: "5dd0d2d5-1ebd-4c3d-8b25-711e6530b876" },
  { slNo: 9, description: "Policy for setting up Mobile Communication towers, Dated 22-08-2016 and 4-10-2006 and Clarification on Appendix-9 in HPTCP Rules -2014.", date: '05-Aug-2016', pdfUrl: "8b51164f-e483-4a59-9c1d-5102d95de0d3" },
  { slNo: 10, description: "Revised Sujanpur Planning Area", date: '19-Jul-2016', pdfUrl: "4151868c-67e5-4409-a3f4-ad4ab972f61c" },
  { slNo: 11, description: "Revised Joginder nager Planning area", date: '19-Jul-2016', pdfUrl: "848cf44c-dd2f-4311-b0d3-20d13bdeecf1" },
  { slNo: 12, description: "Revised Ghumarwin Planning Area ", date: '19-Jul-2016', pdfUrl: "6292b147-2e07-4231-bbfc-a13e32b436a3" },
  { slNo: 13, description: "Revised Bhota Planning Area ", date: '19-Jul-2016', pdfUrl: "a15dedcc-3196-48b5-8009-051e2db97055" },
  { slNo: 14, description: "Ceasing of Shri Naina Devi Ji Planning Area", date: '19-Jul-2016', pdfUrl: "b5073eaa-e07d-492c-9ad9-7a1f91ec3c5b" },
  { slNo: 15, description: "Extention in Bilaspur Planning Area", date: '19-Jul-2016', pdfUrl: "50e21f8e-c02e-4782-9bf2-b002ce17e1f4" },
  { slNo: 16, description: "Public Service Guarantee Act",date: '05-Apr-2016', pdfUrl: "303828e7-eab3-41f9-ba99-22b65ef330b8" },
  { slNo: 17, description: "Kasauli Development Plan amendment notification", date: '20-Nov-2015', pdfUrl: "e4b53195-70c1-45d7-a7e2-59862fa81004" },
]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const NotificationTCP = () => { 
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Other Notifications
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>SL. No</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Headline</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Notification Date</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Download</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell>{row.date}</StyledTableCell>
              <StyledTableCell onClick={() => getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default NotificationTCP;
